let url;

let URLENV_="pro";

if (URLENV_== "pro") {
    url = {
        ucWeb: "https://middle.5ibazhuayu.com.cn",
        upload:"https://www.5ibazhuayu.com.cn/uploadPdf",
       // jumpurl:"https://www.5ibazhuayu.com.cn/html/head/index_1.html",
        indexHtml:"https://www.5ibazhuayu.com.cn",
        jumpurl:"https://www.5ibazhuayu.com.cn/html/index.html",
        gjurl:"http://35ye71rfj.lightyy.com/octopus-login.html",
        cms2Url:"https://cmsadmin.5ibazhuayu.com.cn",
        weixin:"https://mobile.5ibazhuayu.com.cn",
        activitysrc:"https://uc.5ibazhuayu.com.cn/upload/"
    };
} else if (URLENV_ == "uat") {
    url = {
        ucWeb: ""
    };
} else if (URLENV_ == "test") {
    url = {
        ucWeb: "http://192.168.49.221:8050",
        gjurl:"http://ym2w2kky4.lightyy.com/octopus-login.html",
        //jumpurl:"http://localhost:10011/#/",
        upload:"http://uc.test-5ibzy.com:28021/uploadPdf",
        indexHtml:"http://www.test-5ibzy.com:28020", 
        jumpurl:"http://www.test-5ibzy.com:28020/html/index.html",
        activitysrc:"http://uc.test-5ibzy.com:28021/upload/",
        weixin:"http://wein.natapp1.cc",
        cms2Url:"http://192.168.49.221:8091",
    };
} else if (URLENV_ == "kf") {
    url = {
        ucWeb: "http://192.168.243.185:8050",
        // ucWeb: "http://192.168.243.193:18571",
      //  jumpurl:"http://localhost:10011/#/",
        jumpurl:"http://www.test-5ibzy.com:28020/html/head/index_1.html",
        upload:"http://192.168.243.185:8030/upload",
    //    cms2Url:"http://192.168.243.185:8091",
        activitysrc:"http://uc.dev-5ibzy.com:8030/upload/",
        indexHtml:"http://www.test-5ibzy.com:28020", 
        cms2Url:"http://192.168.49.221:8091",
    };
};

module.exports = url; 


// WEBPACK FOOTER //
// ./src/config/url.js